<ng-template #reservationModalFormContent role="document" let-modal>

  @if(!embeddedFormMode) {
    <app-modal-comp-header
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm(); modal.dismiss('Cross click')"
    ></app-modal-comp-header>
  }

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form (ngSubmit)="saveFormData()" [formGroup]="reservationForm" class="tablelist-form" autocomplete="off">
      <div class="modal-body">

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                <span [innerHtml]="progressInformation"></span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="alert border-0 {{alertColourOrderStatus}}" role="alert">
                <strong>Reservation Status</strong> - <span [innerHtml]="orderStatusInformation" ></span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="inviewCompanyId-field" class="form-label text-right">Company</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="inviewCompanyId-field"
                  id="inviewCompanyId-field"
                  formControlName="inviewCompanyId"
                  (change)="inviewCompanySelectDropDownChange($event)"
                  [ngClass]="{ 'is-invalid': formSubmitted && formData['inviewCompanyId'].errors }"
                >
                  <option selected></option>
                  @for (object of getDropdownDataObjectArray("inviewCompanyId"); track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                @if(registerInviewCompany) {
                  <button class="btn btn-danger" type="button" [disabled]="!addCompanyButtonEnabled" (click)="addInviewCompany()">Register</button>
                } @else {
                  <button class="btn btn-success" type="button" [disabled]="!addCompanyButtonEnabled" (click)="addInviewCompany()">Add</button>
                }
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="deviceTypeId-field" class="form-label text-right">Sim Type</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="deviceTypeId-field"
                  id="deviceTypeId-field"
                  formControlName="deviceTypeId"
                  (change)="deviceTypeSelectDropDownChange($event)"
                  [ngClass]="{ 'is-invalid': formSubmitted && formData['deviceTypeId'].errors }"
                >
                  <option selected></option>
                  @for (object of getDropdownDataObjectArray("deviceTypeId"); track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="reservationNumber-field" class="form-label text-right">Number of Reservations</label>
              <div class="input-group">
                <dx-number-box
                  [(ngModel)]="numberValue"
                  [ngModelOptions]="{standalone: true}"
                  name="reservationNumber"
                  id="reservationNumber"
                  [value]=5
                  [min]=0
                  [max]=50
                  [showSpinButtons]="true"
                  [showClearButton]="true"
                  [step]=5
                  [ngClass]="{ 'is-invalid': formSubmitted && formData['reservationNumber'].errors }">
                </dx-number-box>
                @if(formData["reservationNumber"].hasError("min") || formData["reservationNumber"].hasError("max")) {
                    <div class="invalid-feedback">Number of Reservations must be a value between 1 and 50</div>
                } @else if(formData["reservationNumber"].hasError("pattern")) {
                    <div class="invalid-feedback">Number of Reservations must contain number characters only</div>
                } @else {
                    <div class="invalid-feedback">A value is required</div>
                }
              </div>
            </div>
          </div>
        </div> -->

        @if(selectedICCID != "") {
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="deviceId-field" class="form-label text-right">ICCID</label>
                <div class="input-group">
                  <select
                    class="form-select"
                    name="deviceId-field"
                    id="deviceId-field"
                    #deviceId
                    formControlName="deviceId"
                    (change)="deviceSelectDropDownChange($event)"
                    [ngClass]="{ 'is-invalid': formSubmitted && formData['deviceId'].errors }"
                  >
                    <option selected></option>
                    @for (object of getDropdownDataObjectArray("deviceId"); track object.id) {
                      <option [ngValue]="object.id">{{object.description}}</option>    
                    }
                  </select>
                  @if(formData["deviceId"].hasError("alreadyProvisioned")) {
                    <div class="invalid-feedback">Please select different ICCID, this one is no longer available</div>
                  } @else {
                    <div class="invalid-feedback">A value is required</div>
                  }
                </div>
              </div>
            </div>
          </div>
  
          <div hidden class="row">
            <div class="col-12">
              <div class="mb-3">
                <label hidden for="iccid-field" class="form-label text-right">ICCID</label>
                <input autocomplete="no-fill" hidden type="text" id="iccid-field" class="form-control text-end border-0 text-bg-light" placeholder="" formControlName="iccid" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formData['iccid'].errors }" />
              </div>
            </div>
          </div>
        }
        @else {
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="reservationNumber-field" class="form-label text-right">Number of Reservations</label>
                <input autocomplete="no-fill" type="text" id="reservationNumber-field" #eidfield class="form-control text-end" placeholder="" formControlName="reservationNumber" data-lpignore="true" [ngClass]="{ 'is-invalid': formSubmitted && formData['reservationNumber'].errors }" />
                  <!-- @if(formData["reservationNumber"].hasError("min") || formData["reservationNumber"].hasError("max")) {
                      <div class="invalid-feedback">Number of Reservations must be a value between 1 and {{ this.maxReservationsAllowed }}</div>
                  } @else  -->
                  @if(formData["reservationNumber"].hasError("min")) {
                      <div class="invalid-feedback">Number of Reservations must be greater than zero</div>
                  } @else if(formData["reservationNumber"].hasError("pattern")) {
                      <div class="invalid-feedback">Number of Reservations must contain number characters only</div>
                  } @else {
                      <div class="invalid-feedback">A value is required</div>
                  }
              </div>
            </div>
          </div>
        }
        <div class="row mb-4"></div>

        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              @if(!embeddedFormMode) {
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm();modal.close('Close click')">Close</button>
              }
              <button type="submit" class="btn btn-success" id="add-btn" [disabled]="!reservationButtonEnabled">Reserve</button>
            </div>
          </div>
        </div>

      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>

  <app-spinner-overlay-wrapper #spinnerOverlayWrapperComponent
    [showSpinner]="this.reservationInProgress"
  ></app-spinner-overlay-wrapper>

</ng-template>

<app-company-modal-form #companyModalForm
  [inputInviewCompanyId]="this.selectedInviewCompanyId"
  (inviewCompanyDataHasBeenSaved)="inviewCompanyHasBeenSaved($event)"
></app-company-modal-form>
  
<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
